import { Agent } from './agent';

// Lista costante delle metriche obiettivo
export const GOAL_METRICS = ['rumors', 'prospects', 'assignments', 'sales'] as const;

export const CONVERSION_RATES = ['cr1', 'cr2', 'cr3'] as const;

// Tipo derivato dalle chiavi di metrica
export type GoalMetric = typeof GOAL_METRICS[number];

export type ConversionRate = typeof CONVERSION_RATES[number];

// Stato della performance
export type PerformanceRating =
  | 'CRITICAL'
  | 'BELOW_EXPECTATIONS'
  | 'NEARLY_ON_TRACK'
  | 'ON_TRACK'
  | 'ABOVE_EXPECTATIONS';

// Dettaglio della metrica di performance
export interface PerformanceMetric {
  goal: number;
  expected: number;
  performance: number;
  delta: number;
  forecast: number;
  progress: number;
  status: PerformanceRating;
}

// Dettaglio della conversione (es. CR1, CR2, etc.)
export interface ConversionMetric {
  goal: number;
  performance?: number;
  progress?: number;
  status?: PerformanceRating;
}

export type TargetAgentType =
  | 'COMMON'
  | 'ACTIVE'
  | 'COMPETITIVE'
  | 'DOMINATIVE'
  | 'LEGENDARY';

export type TimeRange = 'yearly' | 'monthly' | 'weekly';

// Obiettivo individuale assegnato a un agente
export interface IndividualGoal {
  agentId: number,
  enrolmentPercentage: number,
  target: number,
  averageCommission: number,
  targetAgentType: TargetAgentType,
  metrics: Record<GoalMetric, Record<TimeRange, PerformanceMetric>>,
  conversions: Record<ConversionRate, ConversionMetric>,
}

export interface ManagerGoal {
  agentId: number,
  enrolmentPercentage: number,
  target: ManagerGoalTarget & WithIssues<IssueMissingTarget>;
  averageCommission: number,
  metrics: Record<GoalMetric, Record<TimeRange, PerformanceMetric & WithIssues<IssueBelowTarget>>>,
  conversions: Record<ConversionRate, ConversionMetric & WithIssues<IssueBelowTarget>>,
}

export interface ManagerGoalTarget {
  manager: number,
  team: number,
}

export interface WithIssues<TIssue extends Issue = Issue> {
  issues?: TIssue[],
}

export type IssueType = 'BELOW_TARGET' | 'MISSING_TARGET';

export interface Issue {
  type: IssueType,
  agent: Required<Pick<Agent, 'id' | 'name'>>,
  value?: number,
}

export interface IssueMissingTarget extends Issue {
  type: 'MISSING_TARGET'
  value?: undefined,
}

export interface IssueBelowTarget extends Issue {
  type: 'BELOW_TARGET',
  value: number,
}
